import axios from 'axios';

import { fetchMe } from '../../actions/me';
import axiosConfig from '../axiosConfig';

let updateUserSession;

const updateSession = store => next => action => {
    const { me } = store.getState();
    const interval = 300000;
    if (interval > 0 && 'user' in me && action?.type.includes('_REQUEST')) {
        clearInterval(updateUserSession);
        updateUserSession = setInterval(() => {
            fetchMe()(store.dispatch, store.getState, { axios: axios.create(axiosConfig) });
        }, interval);
    }

    return next(action);
};

export default updateSession;
